import React from "react"
import {Route, IndexRoute} from "react-router"

import PageLayout from "./layout/PageLayout"
import BaseLayout from "./layout/BaseLayout"
import EmptyLayout from "./layout/EmptyLayout"
import CheckoutLayout from "./layout/CheckoutLayout"

import AllPage from "./pages/AllPage"
import HomePage from "./pages/HomePage"
import DemoPage from "./pages/DemoPage"
import CollectionPage from "./pages/CollectionPage"
import BrandPage from "./pages/BrandPage"
import ProductPage from "./pages/ProductPage"
import SearchPage from "./pages/SearchPage"
import QuickorderPage from "./pages/quickorder/QuickorderPage"
import CmsPage from "./pages/CmsPage"
import LoginPage from "./pages/LoginPage"
import SalesPage from "./pages/SalesPage"
import CheckoutPage from "./pages/checkout/CheckoutPage"
import SuccessPage from "./pages/checkout/SuccessPage"
import ConfirmationPage from "./pages/checkout/ConfirmationPage"
import DeliveryPage from "./pages/checkout/DeliveryPage"
import ThemenPage from "./pages/ThemenPage"
import AccountPage from "./pages/AccountPage"
import AccountOrderDetailPage from "./pages/AccountOrderDetailPage"
import OrderlistPage from "./pages/orderlist/OrderlistPage"

import RegisterPage from "./pages/RegisterPage"
import NotFoundPage from "./pages/NotFoundPage"
import AdminPage from "./pages/AdminPage"

// FROM THEME
import LogoutPage from "./theme/pages/LogoutPage"
import RequestPasswordPage from "./theme/pages/RequestPasswordPage"
import NewCustomerPage from "./theme/pages/NewCustomerPage"
import CustomerEnablingPage from "./theme/pages/CustomerEnablingPage"

// CONTACT FORMS
import FormPage from "./theme/pages/form/FormPage"
import UploadPage from "./theme/pages/form/UploadPage"
import FormDebuggerPage from "./theme/pages/form/FormDebuggerPage"

const SpecialsPage = (props) => <SalesPage {...props} pathname="special"/>

function loginWall({ location }) {
  location.state = { access: false }
}

const routes = (
  <Route
    path="/"
         component={PageLayout}>
    <Route component={BaseLayout}>
      <Route
        path="demo"
        component={DemoPage}/>
      <IndexRoute component={HomePage}/>
      <Route
        path="home"
        component={HomePage}/>

      <Route
        path="all"
        component={AllPage}/>

      <Route
        path="account"
        component={AccountPage}/>

      <Route
        path="themenwelten"
        component={ThemenPage}/>

      <Route
        path="topseller/:mode"
        component={SalesPage}/>

      <Route
        path="topseller"
        component={SalesPage}/>

      <Route
        path="articletype/:mode"
        component={SalesPage}/>

      <Route
        path="articletype"
        component={SalesPage}/>

      <Route
        path="special/:mode"
        component={SpecialsPage}/>

      <Route
        path="special"
        component={SpecialsPage}/>

      <Route
        path="form/:slug"
        component={FormPage}/>

      <Route
        path="upload"
        component={UploadPage}/>

      <Route
        path="form-debugger/:slug"
        component={FormDebuggerPage}/>

      <Route
        path="account/orders/:orderId"
        component={AccountOrderDetailPage}/>

      <Route
        path="collection">
        <IndexRoute component={CollectionPage}/>
        <Route
          path="/collection/:parent"
          component={CollectionPage}>
          <Route
            path=":id"
            component={CollectionPage}/>
        </Route>
      </Route>

      <Route
        path="/brand/:id"
        component={BrandPage}/>

      <Route
        path="product"
        component={ProductPage}/>
      <Route
        path="product/:id"
        component={ProductPage}/>

      <Route
        path="ean/:ean"
        component={ProductPage}/>


      <Route
        path="quickorder"
        component={QuickorderPage}/>

      <Route
        path="orderlist"
        component={OrderlistPage}/>
      <Route
        path="orderlist/:id"
        component={OrderlistPage}/>
      <Route
        path="cms/:slug"
        component={CmsPage}/>
      <Route
        path="search"
        component={SearchPage}/>
      <Route
        path="register"
        component={RegisterPage}> </Route>
      <Route
        path="admin"
        component={AdminPage}> </Route>
    </Route>

    {/*LOGIN ROUTES*/}
    <Route component={EmptyLayout}>
      <Route
        path="login"
        component={LoginPage}/>

      <Route
        path="reset_password"
        component={RequestPasswordPage}/>

      <Route
        path="customer_registration"
        component={NewCustomerPage}/>
      <Route
        path="customer_enabling"
        component={CustomerEnablingPage}/>

      <Route path="logout"
             component={LogoutPage}/>
    </Route>


    <Route path="checkout"
           component={CheckoutLayout}
           onEnter={loginWall}
    >
      <IndexRoute component={CheckoutPage}/>
      {/*<Route  path="cart" component={CartPage}></Route>*/}
      <Route
        path="delivery"
        component={DeliveryPage}> </Route>
      <Route
        path="confirmation"
        component={ConfirmationPage}> </Route>
      <Route
        path="success"
        component={SuccessPage}> </Route>
    </Route>

    <Route component={BaseLayout}>
      <Route path="*"
             component={NotFoundPage}/>
    </Route>
  </Route>
)

export default routes



// WEBPACK FOOTER //
// ./src/routes.js